import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { SiteContentProvider } from "@/lib/content";
import HomePage from "@/pages/HomePage";
import ArticlePage from "@/pages/ArticlePage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminResetPasswordPage from "@/pages/AdminResetPasswordPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-[var(--ekal-bg)] min-h-screen text-slate-100">
      <SiteContentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/article/:id" element={<ArticlePage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/reset-password" element={<AdminResetPasswordPage />} />
            <Route path="/admin" element={<AdminDashboardPage />} />
          </Routes>
        </BrowserRouter>
      </SiteContentProvider>
      <Toaster position="top-right" theme="dark" richColors />
    </div>
  );
}

export default App;
